import { flattenDeep, maxBy, minBy } from 'lodash';
import * as constants from '@biw/contests-constants';
import { formatDate, formatNumber } from '@biw/intl';
import parseDate from 'date-fns/parse';

export const getXTickValues = ( max ) => {

    const points = [];
    let currentTick = 0;
    let tickCount;

    if ( max > 0 ) {
        tickCount = 2;
    }
    if ( max > 14 ) {
        tickCount = 5;
    }
    if ( max > 44 ) {
        tickCount = 6;
    }
    if ( max > 89 ) {
        tickCount = 15;
    }
    if ( max > 179 ) {
        tickCount = 30;
    }
    if ( max > 400 ) {
        tickCount = 40;
    }
    if ( max > 600 ) {
        tickCount = 80;
    }
    if ( max > 800 ) {
        tickCount = 160;
    }

    do {
        points.push( currentTick );
        currentTick += tickCount;
    } while ( currentTick <= max );

    return points;
};

export const getLineValues = ( min, max, goal ) => {
    return [ { day: min, value: goal }, { day: max, value: goal } ];
};

export const getTrendValues = ( data, onTrackDay ) => {

    let lastDay;

    if ( onTrackDay.value ) {
        lastDay = onTrackDay;
    } else {
        lastDay = data[ data.length - 1 ];
    }

    return  [ data[ data.length - 1 ], lastDay ];
};

export const getMaxValue = ( data, attribute ) => {

    const data2 = flattenDeep( data );
    const array = [];

    for ( let i = 0; i < data2.length; i++ ) {
        if ( data2[ i ] && data2[ i ][ attribute ] ) {
            array.push( data2[ i ][ attribute ] );
        }
    }

    return maxBy( array );
};

export const getMinValue = ( data, attribute ) => {
    return minBy( flattenDeep( data ), `${attribute}` )[ attribute ];
};

export const getYDomainValues = ( min, max ) => {
    let min2 = 1,
        max2 = 1;

    if ( min <= 0 ) {
        min2 = min + ( min / 3 );
    }

    if ( max >= Math.abs( min2 ) ) {
        max2 = max + ( max / 3 );
    } else {
        max2 = Math.abs( min2 ) * .333;
    }

    return [ min2, max2 ];
};

export const getAreaValues = ( days, onTrackDay, calculationType, programViewStatus ) => {

    const areaValues = days.slice();

    if ( onTrackDay.value && programViewStatus !== constants.PVS__FINAL_ISSUANCE ) {
        areaValues.push( onTrackDay );
    }

    return areaValues;
};

export const getToolTipValue = ( data, goalLabel, locale ) => {

    const { precision, labelPosition, labelText, labelType, currencyCode } = goalLabel;
    const formattedDate = formatDate( locale, parseDate( data.date ) );
    const labelText2 = labelText ? labelText : '';

    const formatOpts = { maximumFractionDigits: precision, minimumFractionDigits: precision };
    let { value } = data;
    switch ( labelType ) {
        case 'currency':
            formatOpts.style = 'currency';
            formatOpts.currency = currencyCode;
            break;
        case 'percentage':
            formatOpts.style = 'percent';
            value = value / 100;
            break;
    }
    let label = formatNumber( locale, formatOpts, value );

    if ( labelPosition === 'before' ) {
        label = `${labelText2} \n ${label} \n ${formattedDate}`;
    } else {
        label = `${label} \n ${labelText2} \n ${formattedDate}`;
    }

    return label;
};
